import { useContext } from "react";
import { Table } from '../../../components/table/Table';
import Loader from "../../../components/loader/Loader";
import { FeatureContext } from "../../../Context";
import { lang } from "../../../Utils";

const Enquiries = () => {

  const context = useContext(FeatureContext);

  const onRowClick = (value) => {
    if (!!value.enquiryUrl) {
      window.location.href = value.enquiryUrl;
    }
  }

  if (context.loading) {
    return <Loader />
  } else {
    return <div>
      <Table
        pagination={true}
        dataSet={context?.enquiries?.data?.enquiries} >
        <Table.Caption>{lang('Enquiries List')}</Table.Caption>
        <Table.Header>
          <Table.Header.Column sortKey={"enquiryId"} sortable={true}>{lang('#')}</Table.Header.Column>
          <Table.Header.Column sortKey={"subject"} sortable={true}>{lang('Subject')}</Table.Header.Column>
          <Table.Header.Column sortKey={"notes"} sortable={true}>{lang('Notes')}</Table.Header.Column>
          <Table.Header.Column sortKey={"createdDate"} sortable={true}>{lang('Created Date')}</Table.Header.Column>
          <Table.Header.Column sortable={false}>{lang('Status')}</Table.Header.Column>
          <Table.Header.Column sortable={false}>{lang('Favourite')}</Table.Header.Column>
        </Table.Header>
        <Table.Body noDataMessage={lang('No Data available to display')}>
          <Table.Body.Text onClick={onRowClick} label={lang('Enquiry Id')} field="enquiryId" />
          <Table.Body.Text onClick={onRowClick} label={lang('Subject')} field="subject" />
          <Table.Body.LongText onClick={onRowClick} length={80} label={lang('Notes')} field="notes" />
          <Table.Body.Date onClick={onRowClick} label={lang('Created Date')} field="createdDate" />
          <Table.Body.Translate onClick={onRowClick} label={lang('Status')} field="status" />
          <Table.Body.Favourite label={lang('Favourite')} field="enquiryUrl" />
        </Table.Body>
      </Table>
    </div>
  }
}

export default Enquiries;